<template lang="pug">
#drawer-menu-area
    el-drawer(
        :title='$t("mensagens.menuMapa.area")',
        direction='rtl',
        :class='menuMaior ? "drawer-menu-area" : "drawer-menu-area menor"',
        :visible.sync='show',
        :before-close='closeDrawerMenuArea',
        :wrapperClosable='false',
        :modal='false',
        :lock-scroll='true',
        :append-to-body='false',
        :close-on-press-escape='true',
        :size='menuMaior ? 360 : 247'
    )
        template(slot='title', slot-scope='scope')
            div(:class='menuMaior ? "titulo-drawer" : "titulo-drawer-menor"')
                i.mdi.mdi-vector-square.mdi-flip-h
                |
                | {{ title }}

        .card-container
            el-menu(
                :default-active='defaultActive',
                :class='menuMaior ? "" : "menu-menor"',
                :collapse='false',
                @select='processarEscolhaMenu'
            )
                div(v-for='item in itemsMenuArea', :key='item.index')
                    el-menu-item(
                        v-if='!item.hasSubOptions && item.hasPermission',
                        :index='item.index',
                        :disabled='item.disabled'
                    )
                        i(:class='item.icon')
                        span(slot='title') {{ item.name }}
                            i(
                                v-if='item.hasSubOptions',
                                :class='item.hasSubOptions ? "mdi mdi-vector-square ml-1" : "mdi mdi-vector-square ml-1"'
                            )
</template>

<script>
export default {
    name: 'DrawerMenuArea',

    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        },
        mapConfigControls: {
            type: Object,
            required: true,
            default: () => {
                return {};
            }
        },
        limparMenuAreaAtivo: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            title: this.$t('mensagens.menuMapa.area'),
            defaultActive: '',
            itemsMenuArea: [
                {
                    index: '0',
                    icon: 'mdi mdi-vector-square',
                    name: this.$t('mensagens.menuMapa.calcularArea'),
                    hasSubOptions: false,
                    hasPermission: true
                },
                {
                    index: '1',
                    icon: 'mdi mdi-set-square',
                    name: this.$t('mensagens.menuMapa.regua'),
                    hasSubOptions: false,
                    hasPermission: true
                }
            ]
        };
    },

    watch: {
        limparMenuAreaAtivo(newValue) {
            if (newValue) {
                this.defaultActive = '';
                setTimeout(() => {
                    this.$emit('resetarLimparMenuAreaAtivo');
                }, 100);
            }
        }
    },

    methods: {
        closeDrawerMenuArea() {
            this.$emit('closeDrawerMenuArea');
        },

        processarEscolhaMenu(opcao) {
            this.defaultActive = opcao;
            if (opcao === '0') {
                this.$emit('drawControlCalc');
                if (this.defaultActive === 0) {
                    let isActive = document.querySelector(
                        '#drawer-menu-area .is-active'
                    );
                    if (isActive) {
                        isActive.classList.remove('is-active');
                    }
                }
            } else if (opcao === '1') {
                this.$emit('rulerActivate');
            }
            this.$emit('closeDrawerMenuArea');
        }
    }
};
</script>

<style lang="scss">
#drawer-menu-area {
    font-family: 'Roboto', 'sans serif';

    .el-drawer.rtl {
        border-radius: 0 3px 3px 0;
    }

    .drawer-menu-area {
        z-index: 500 !important;
        position: absolute;

        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 16px;
            }
        }
    }

    .drawer-menu-area.menor {
        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 14px;
            }
        }
    }

    .el-drawer__body {
        @include scroll-bar();
    }

    .card-container {
        height: 100%;
        background-color: var(--white);
        padding: 5px 8px;
        overflow-y: auto;
        overflow-x: hidden;

        .el-menu {
            width: 100%;
            border-right: none;
            display: flex;
            flex-direction: column;

            .el-menu-item,
            .el-submenu__title {
                padding: 0;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding-left: 8px !important;
                height: 42px;
                line-height: 42px;

                i {
                    color: #3b3b3b;
                    transition: all 0.3s ease-in-out;
                }

                i.mdi {
                    margin-right: 11px;
                    text-align: center;
                    font-size: 22px;
                    vertical-align: middle;
                }

                i.el-icon-arrow-down {
                    transform: rotate(270deg);
                    color: #3b3b3b;
                    font-size: 16px;
                    font-weight: 600;
                }

                span {
                    width: 100%;
                    color: #3b3b3b;
                    font-weight: 400;
                    font-size: 14px;
                    transition: color 0.3s ease-in-out;
                    display: flex;
                    justify-content: space-between;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    line-height: 16px;
                    letter-spacing: 0em;
                    text-align: left;
                }

                .el-tooltip {
                    padding: 0px 18px;
                }
            }

            .el-submenu__icon-arrow {
                right: 10px;
            }

            .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
                transform: rotate(360deg) !important;
            }

            .el-menu-item.is-active {
                color: var(--primary);
                background-color: #b5dc6966;

                i {
                    color: var(--primary);
                }

                span {
                    color: var(--primary);
                    font-weight: 500;
                }
            }
        }

        .el-menu.menu-menor {
            width: 100%;
            border-right: none;
            display: flex;
            flex-direction: column;

            .el-menu-item,
            .el-submenu__title {
                padding: 0;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding-left: 8px !important;
                height: 42px;
                line-height: 42px;

                i {
                    color: #3b3b3b;
                    transition: all 0.3s ease-in-out;
                }

                i.mdi {
                    margin-right: 11px;
                    text-align: center;
                    font-size: 18px;
                    vertical-align: middle;
                }

                i.el-icon-arrow-down {
                    transform: rotate(270deg);
                    color: #3b3b3b;
                    font-size: 14px;
                    font-weight: 600;
                }

                span {
                    width: 100%;
                    color: #3b3b3b;
                    font-weight: 400;
                    font-size: 13px;
                    transition: color 0.3s ease-in-out;
                    display: flex;
                    justify-content: space-between;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    line-height: 16px;
                    letter-spacing: 0em;
                    text-align: left;
                }

                .el-tooltip {
                    padding: 0px 18px;
                }
            }

            .el-submenu__icon-arrow {
                right: 10px;
            }

            .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
                transform: rotate(360deg) !important;
            }

            .el-menu-item.is-active {
                color: var(--primary);
                background-color: #b5dc6966;

                i {
                    color: var(--primary);
                }

                span {
                    color: var(--primary);
                    font-weight: 500;
                }
            }
        }

        .el-menu:not(.el-menu--collapse) {
            width: 100%;

            &::before {
                content: '';
                position: absolute;
                width: 32px;
                height: 15px;
                top: -5px;
                right: -32px;
                border-radius: 32px 10px 40px 10px;
                -webkit-box-shadow: -20px -20px 0 var(--primary);
                box-shadow: -14px -3px 0 var(--primary);
                z-index: -1;
            }
        }
    }

    .titulo-drawer {
        font-size: 17px;
        font-weight: 500;
        color: var(--primary);
    }

    .titulo-drawer-menor {
        font-size: 15px;
        font-weight: 500;
        color: var(--primary);
    }

    .text-align-right {
        text-align: right;
    }

    .float-box .float-box-title h2 {
        padding-top: 19px;
        font-size: 16px;
        padding-right: 16px;
        padding-left: 22px;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .pull-left {
        float: left;
    }

    .el-drawer__header {
        background-color: #e9e9e9;
        padding: 15px !important;
        margin-bottom: 0px;
    }

    .float-box-title {
        width: 100%;
        background-color: #ecf0f1;
    }

    .float-box .float-box-collapse-icon {
        position: absolute;
        right: 15px;
        top: 17px;
        z-index: 10001;
        font-size: 16px;
    }

    .action-icon {
        cursor: pointer;
        color: #777;
    }
}
</style>
